import React, { useRef, useState, useEffect } from 'react';
import { Protected } from '@components/layout/Protected';
import { Props } from './UsersAreaNegocio.type';
import { authenticationService } from '@service/services/Authentication.service';
import { Loading } from "@components/common/Loading";
import { FormControl, Autocomplete, Select, MenuItem, Container, Divider, Grid, InputLabel, TextField, Typography, Button, Alert, Snackbar, Backdrop, CircularProgress } from '@mui/material';
import { ModalCreateContact } from '@/components/common/Modal';
import { TableData } from '@/components/common/Table';
import { TabsComponent } from '@/components/common/Tabs/index';
import { ROUTE_ENTITY_CREATE, ROUTE_ENTITY_USERS, ROUTE_USER_BY_AREA_NEGOCIO_CREATE, ROUTE_USER_BY_AREA_NEGOCIO_UPDATE } from '@/toolbox/constants/route-map';
import { AreaNegocioService } from '@/service/services/AreaNegocio.service';
import { Link } from 'react-router-dom';
import { ConfirmDialog } from '@components/common/DialogConfirm';
import { entityService } from '@/service/services/Entity.service';
import { readLocalStorage } from '@/toolbox/helpers/local-storage-helper';
import { KEY_USER_DATA } from '@/toolbox/constants/local-storage';
import userReducer from '@/redux/reducers/user.reducer';
import { MenuLateral } from '@/components/common/LateralMenu';
import {useHistory} from 'react-router-dom'

export const UserAreaNegocioView: React.FC<Props> = (props: Props): JSX.Element => {
   const header = [
      { name: 'nombre', label: 'Nombre', width: '' },
      { name: 'email', label: 'Email', width: '' },
      { name: 'telefono', label: 'Telefono', width: '' },
      { name: 'area_negocio', label: 'Area', width: '' }]
   const dataAction = [
      { name: 'view', color: 'success', route: ROUTE_USER_BY_AREA_NEGOCIO_UPDATE },
      { name: 'edit', color: 'primary', route: ROUTE_USER_BY_AREA_NEGOCIO_UPDATE },
      { name: 'delete', color: 'secondary', route: null }
   ]
   const history= useHistory();
   const [open, setOpen] = useState(false);
   const [dataAreaNegocio, setDataAreaNegocio] = useState<any>([])

   console.log(props.user)

   useEffect(() => {
      const data = readLocalStorage(KEY_USER_DATA)
      if (props.user !== undefined) {
         getUsersByArea(props.user.idarea_negocio)
      } else {
         getUsersByArea(data.user.idarea_negocio)
      }
   }, [])

   async function getUsersByArea(idarea_negocio) {
      setOpen(true)
      const resp:any = await AreaNegocioService.getUsersByArea(idarea_negocio);
      console.log(resp.data.length)
      setDataAreaNegocio(resp.data.length==0?[]:resp.data.trabajadores);
      setOpen(false)
   }

   return (
      <Protected>
         <Backdrop
            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={open}
         >
            <CircularProgress color="inherit" />
         </Backdrop>
         <Container maxWidth='xl' sx={{ mt: 1 }}>
            <Grid container flexDirection='row' spacing={2}>
            <Grid item md={3} container>
                  <MenuLateral />
               </Grid>
               <Grid item md={9}
                  sx={{ width: '100%', bgcolor: 'background.paper', height: '77vh', overflowX: 'hidden', overflowY: 'scroll', borderRadius: '0.5rem', border: '0.5px solid #eff3f5', borderLeft: '5px solid #1976D2 ', mt: 3 }}
               >
                  <Grid container sx={{ pt: 1, pb: 1, pl: 3, pr: 3 }}>
                     <Grid container rowSpacing={1}>
                        <Grid item container xs={6} rowSpacing={2} >
                           <Grid item xs={12}>
                              {props.user ? (
                                 <Typography sx={{color:'#155172', fontWeight:'700', fontSize:'2.5em'}}>{`AREA DE ${props.user?.descripcion}`}</Typography>
                              ) :
                                 <Typography sx={{color:'#155172', fontWeight:'700', fontSize:'2.5em'}}>{`MIS USUARIOS`}</Typography>}
                           </Grid>
                           <Grid item xs={12}>
                              <Button variant='contained'
                               sx={{background:'#155172',ml:2, color:'#fff','&:hover':{
                                 bgcolor:'#155172'
                                }
                              }}
                              onClick={()=>{history.push(ROUTE_USER_BY_AREA_NEGOCIO_CREATE, props.user.idarea_negocio)}}>Agregar Usuario Trabajador</Button>
                           </Grid>
                        </Grid>
                        <Grid item xs={12} >
                           <TextField
                              margin="normal"
                              required
                              fullWidth
                              name="text"
                              placeholder="Buscar"
                              type="search"
                              id="password"
                              autoComplete="current-password"
                              size="small"
                           />
                        </Grid>
                        <Grid item xs={12}>
                           <Typography variant="body2" sx={{ mt: '20px' }} >
                           {`${dataAreaNegocio.length ? `${dataAreaNegocio.length}` : `0`} Registros encontrados`}
                           </Typography>
                        </Grid>
                        <Grid item xs={12} >
                           <TableData
                              header={header}
                              data={dataAreaNegocio}
                              action={dataAction} />
                        </Grid>
                     </Grid>
                  </Grid>

               </Grid>
            </Grid>
         </Container>
      </Protected>
   )
};
